import { memo } from 'react';

import './style.css';
import { Main } from './components/Loadable';

const Dashboard = memo(() => {
  return (
    <Main />
    // <div className="dashboard-container bgImageCover fullWidth fullHeight">
    //   <Main />
    // </div>
  );
});

export default Dashboard;
